/**
 * Northern Row Hub
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ToastLevel = 'Light' | 'Medium' | 'Heavy';

export const ToastLevel = {
    Light: 'Light' as ToastLevel,
    Medium: 'Medium' as ToastLevel,
    Heavy: 'Heavy' as ToastLevel
};

